
/* styles */
require("!!vue-style-loader!css-loader!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-2fa7f787&scoped=true!sass-loader!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PCHeader.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PCHeader.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-2fa7f787!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PCHeader.vue"),
  /* scopeId */
  "data-v-2fa7f787",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/global/partials/GuestHeader/PCHeader.vue
// module id = 592
// module chunks = 0